/**
 * Badge Component - Consistent status/label indicators
 * Uses CSS modules with design tokens
 *
 * Variants: 'default', 'primary', 'success', 'error', 'warning', 'info', 'outline'
 * Sizes: 'sm', 'md', 'lg'
 *
 * Examples:
 * <Badge variant="success" size="sm">Active</Badge>
 * <Badge variant="primary">Contact 1</Badge>
 * <Badge variant="outline" style={{borderColor: 'red', color: 'red'}}>Custom</Badge>
 */

import React from 'react';
import styles from './Badge.module.css';

const Badge = ({
  children,
  variant = 'default', // 'default', 'primary', 'success', 'error', 'warning', 'info', 'outline'
  size = 'md', // 'sm', 'md', 'lg'
  className = '',
  style = {},
  ...rest
}) => {
  const badgeClasses = [
    styles.badge,
    styles[variant],
    styles[size],
    className
  ].filter(Boolean).join(' ');

  return (
    <span className={badgeClasses} style={style} {...rest}>
      {children}
    </span>
  );
};

export default Badge;